export default {
  addBtn: 'Add Animation',
  customize: 'Custom Animation',
}
